import Cookies from 'js-cookie';

// 쿠키 이름(key) 변경
export enum CookieKey {
  JEBS_AI_RECITATION = 'JEBS_AI_RECITATION',
  USER_INFO = 'USER_INFO',
  JEBS_AI_RECITATION_RESULT = 'JEBS_AI_RECITATION_RESULT',
}
type sameSite = 'Lax' | 'None' | 'Strict';
export const createCookie = <GData>(key: CookieKey) => {
  const config: Cookies.CookieAttributes = {
    path: '/',
    secure: true,
    sameSite: 'None' as sameSite,
  };

  // INFO: 도메인이 다를 경우 쿠키 생성이 안되므로, 개발 로컬 환경에서는 domain 설정을 제외합니다.
  if (process.env.NODE_ENV !== 'development') {
    config.domain = 'jebs.kr';
  }

  return {
    setCookie: (value: GData, days?: number) => {
      Cookies.set(key, JSON.stringify(value), {
        ...config,
        expires: days,
      });
    },
    getCookie: (): GData => JSON.parse(Cookies.get(key)),
    removeCookie: () => {
      Cookies.remove(key, {
        ...config,
      });
    },
  };
};
